import moment from 'moment';
import css from './DateSeparator.module.css';

interface DateSeparatorProps {
  date: string;
}

export function DateSeparator({ date }: DateSeparatorProps) {
  const formatDate = (dateString: string) => {
    const messageDate = moment(dateString);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');

    if (messageDate.isSame(today, 'day')) {
      return 'Сегодня';
    } else if (messageDate.isSame(yesterday, 'day')) {
      return 'Вчера';
    } else if (messageDate.year() === moment().year()) {
      return messageDate.format('D MMMM');
    } else {
      return messageDate.format('D MMMM YYYY');
    }
  };

  return (
    <div className={css.dateSeparator}>
      <span className={css.dateText}>{formatDate(date)}</span>
    </div>
  );
}
